import { Modal } from "react-bootstrap";
import loadingImg from '../../../assets/img/content/loading-sm.gif';

const Loader = ({ message }: { message?: string }) => {
    const content = message ? message : "Loading...";
    return (
        <Modal
            show={true}
            size="sm"
            centered
            backdrop="static"
            keyboard={false}
            contentClassName="bg-transparent border-0 shadow-none"
            dialogClassName="bg-transparent"
        >
            <Modal.Body style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                padding: "20px",
                backgroundColor: "transparent",
            }}>
                {message ? (
                    <h4
                        style={{
                            fontWeight: 500,
                            fontSize: "18px",
                            color: "white",
                            textShadow: "0 0 5px rgba(0,0,0,0.5)",
                        }}
                    >
                        {message}
                    </h4>
                ) : (
                    <img
                        src={loadingImg}
                        alt="Loading..."
                        style={{
                            width: "60px",
                            height: "60px",
                            background: "transparent",
                        }}
                    />
                )}
            </Modal.Body>
        </Modal>
    );
};
export default Loader;